// eslint-disable-next-line import/prefer-default-export
export const FormProperty = {
  FormGroup: 'formGroup',
  IsLoading: 'isLoading',
  LoadOptionsHandler: 'loadOptionsHandler',
};
